import { Box, Button, ButtonProps, Typography, useTheme } from "@mui/material"
import { deepmerge } from "@mui/utils"

export interface IHomeActionButtonProps extends ButtonProps {
  primary?: string
  secondary?: string
  icon?: React.ReactNode
}

export const HomeActionButton: React.FC<IHomeActionButtonProps> = ({
  primary,
  secondary,
  icon: iconProps,
  sx = {},
  ...props
}) => {
  const theme = useTheme()
  const { root, icon, primaryText, secondaryText, textContainer } =
    theme.components[`HomeActionButton`]?.styleOverrides || {}
  return (
    <Button sx={deepmerge(root, sx)} variant="contained" {...props}>
      <Box sx={icon}>{iconProps}</Box>
      <Box sx={textContainer}>
        <Typography sx={primaryText} className="HomeActionButton-primaryText">
          {primary}
        </Typography>
        <Typography
          sx={secondaryText}
          className="HomeActionButton-secondaryText"
        >
          {secondary}
        </Typography>
      </Box>
    </Button>
  )
}
